import { ArrowDownRight, ArrowUpRight, Scale, Truck } from "lucide-react";
import { money } from "@/lib/format";

const Card = ({ label, value, icon: Icon, tone, hint, testId, delay }) => (
  <div className="surface p-5 fade-up" style={{ animationDelay: `${delay}ms` }} data-testid={testId}>
    <div className="flex items-center justify-between">
      <span className="eyebrow">{label}</span>
      <span className={`h-8 w-8 rounded-lg grid place-items-center ${tone.bg}`}><Icon className={`h-4 w-4 ${tone.fg}`} /></span>
    </div>
    <div className={`mt-3 font-num text-2xl sm:text-[28px] font-semibold tracking-tight ${tone.text}`} data-testid={`${testId}-value`}>{value}</div>
    <div className="mt-1 text-xs text-muted-foreground">{hint}</div>
  </div>
);

export function SummaryCards({ totals }) {
  const net = totals.net_cents;
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4" data-testid="summary-cards">
      <Card label="Income" value={money(totals.income_cents)} icon={ArrowUpRight} testId="card-income" delay={0} hint="Money in"
        tone={{ bg: "bg-emerald-50", fg: "text-emerald-600", text: "text-emerald-700" }} />
      <Card label="Expenses" value={money(totals.expense_cents)} icon={ArrowDownRight} testId="card-expenses" delay={60} hint="Money out"
        tone={{ bg: "bg-rose-50", fg: "text-rose-500", text: "text-rose-600" }} />
      <Card label="Vendor Purchases" value={money(totals.vendor_purchases_cents)} icon={Truck} testId="card-vendor-purchases" delay={120} hint="Stock & supplier spend"
        tone={{ bg: "bg-sky-50", fg: "text-sky-600", text: "text-foreground" }} />
      <Card label="Net Income" value={money(net)} icon={Scale} testId="card-net-income" delay={180} hint={net >= 0 ? "Profit (income − expenses)" : "Loss (income − expenses)"}
        tone={{ bg: net >= 0 ? "bg-emerald-50" : "bg-rose-50", fg: net >= 0 ? "text-emerald-600" : "text-rose-500", text: net >= 0 ? "text-emerald-700" : "text-rose-600" }} />
    </div>
  );
}
